import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../app/stores/store';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { ReportsDynamictableData } from './DynamictableCondition';

function InventoryReports() {
  const { dashboardStore, activityStore, commonStore } = useStore();
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [filterTwoData, setFilterTwoData] = useState<any[]>([]);
  const [name, setName] = useState<string>(
    dashboardStore.dashboard.valueForL3Inventory.replaceAll(' ', ''),
  );
  useEffect(() => {
    setLoading(true);
    setName(dashboardStore.dashboard.valueForL3Inventory.replaceAll(' ', ''));
    activityStore.inventoryReportsFetchTableDetails(
      '',
      1,
      dashboardStore.dashboard.valueForL3Inventory.replaceAll(' ', ''),
    );
    setPageNumber(1);
    setTimeout(() => {
      setLoading(false);
    }, 100);
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.valueForL3Inventory]);

  const caseHandler = () => {
    let tableDetails: any[] = [];
    switch (name) {
      case 'NewAssetAdded':
        tableDetails = activityStore.inventoryReports.newAssetAdded.data;
        break;
      case 'CurrentMonthAssetCANMovement':
        tableDetails =
          activityStore.inventoryReports.currentMonthAssetCANMovement.data;
        break;
      case 'PendingReturnsFromBorrowers':
        tableDetails =
          activityStore.inventoryReports.pendingReturnsFromBorrowers.data;
        break;
      case 'AssetsCleaned':
        tableDetails = activityStore.inventoryReports.assetsCleaned.data;
        break;
      case 'AssetsScheduledForCleaning':
        tableDetails =
          activityStore.inventoryReports.assetsScheduledForCleaning.data;
        break;
      case 'DigitalizationPriority':
        tableDetails =
          activityStore.inventoryReports.digitalizationPriority.data;
        break;
      default:
        tableDetails = [];
    }
    return tableDetails;
  };
  const paginateFunction = (e: number) => {
    let searchValues = dashboardStore.dashboard.searchfilterparams;
    if (
      !_.isEmpty(searchValues) &&
      Object.values(searchValues).every((o) => o !== '') &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      activityStore.inventoryReportsFetchTableDetails(searchValues, e, name);
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      activityStore.inventoryReportsFetchSortTableDetails(
        dashboardStore.dashboard.orderData,
        name,
        dashboardStore.dashboard.orderName || '',
        e || 1,
        (activityStore.inventoryReports as any)[`${_.camelCase(name)}`].count ||
          0,
      );
    } else {
      activityStore.inventoryReportsFetchTableDetails(searchValues, e, name);
    }
    setPageNumber(e);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 100);
  };
  useEffect(() => {
    const ids: any = ReportsDynamictableData.filter(
      (element: any) => name === element.name,
    );
    setFilterTwoData(ids);
  }, [name]);
  return (
    <>
      {commonStore.filterModeTwo.includes(filterTwoData?.[0]?.id) ? (
        <></>
      ) : (
        !!name?.length && (
          <DynamicTableComponent
            key={uuid()}
            data={caseHandler()}
            name={name}
            actiontype={name === 'DigitalizationPriority' ? 'priority' : ''}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            setPageNumber={setPageNumber}
            searchFuncData={() => {}}
            loading={loading}
            isdisabled={commonStore?.filterModeZero?.includes(
              filterTwoData?.[0]?.id,
            )}
          />
        )
      )}
    </>
  );
}

export default observer(InventoryReports);
